import React from 'react';
import { Bullet, PAD, Panel, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { FlowRail } from './visuals';
const SHIFT = [{
  title: 'Sales-led',
  description: 'Rep-driven engagement model'
}, {
  title: 'Marketing-led',
  description: 'Channel-first, under cost pressure'
}, {
  title: 'In-housing',
  description: 'A response to cost, not to quality'
}, {
  title: 'AI-enabled delivery',
  description: 'Agency quality, new cost base'
}];
const CAPABILITIES = ['Strategy', 'Creation', 'Localization', 'Activation', 'Performance visibility'];
const LEO_FACTS = [{
  value: '70+',
  label: 'Countries'
}, {
  value: '25',
  label: 'Brands'
}, {
  value: '60%+',
  label: 'Revenue from legacy'
}, {
  value: '~16%',
  label: 'EBIT vs 30% benchmark'
}];
export function WhyWeExist() {
  return <SlideFrame data-id="element-396" data-mp="1hrfthjsbkfko">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-397" data-mp="1hqxsk9uppd6f">
        <SlideHeader eyebrow="01 — Why we exist" title="Snakker —" accent="why we exist" kicker="Snakker for LEO Pharma" data-id="element-398" data-mp="1mjqs8jbbpvbn" />

        <Reveal delay={0.2} className="mt-[3vh] shrink-0" data-id="element-399" data-mp="pl1wh9orjfe3">
          <p className={`${t.label} mb-[1.4vh] font-semibold uppercase tracking-[0.2em] text-white/45`} data-id="element-400" data-mp="pmmq8x396uaw">
            The shift in the market
          </p>
          <FlowRail steps={SHIFT} data-id="element-401" data-mp="zi6ldh9ztoyl" />
        </Reveal>

        <div className="mt-[2.6vh] grid min-h-0 flex-1 grid-cols-2 gap-[1.4vw]" data-id="element-402" data-mp="zhem9wh6t93k">
          <Reveal delay={0.34} className="flex min-h-0" data-id="element-403" data-mp="1d8taqitv62i0">
            <Panel index="A" label="What Snakker is" className="w-full" data-id="element-404" data-mp="199sr4y3kavty">
              <Bullet data-id="element-405" data-mp="1n8k42h6oubgi">
                A strategic campaign delivery model — not a traditional service
                provider
              </Bullet>
              <div className="mt-[0.6vh] flex flex-wrap gap-[0.5vw]" data-id="element-406" data-mp="1ia8rvzsx7ov4">
                {CAPABILITIES.map(item => <span key={item} className={`${t.label} rounded-full border border-[#7D38E5]/50 bg-[#7D38E5]/[0.14] px-[0.9vw] py-[0.7vh] font-medium text-white/85`} data-id="element-407" data-mp="3p29nf9f7gbkv">
                    {item}
                  </span>)}
              </div>
              <p className={`${t.label} leading-[1.4] text-white/50`} data-id="element-408" data-mp="1wym1gn7iusg0">
                One system, one accountable delivery chain — not five suppliers
                stitched together.
              </p>
            </Panel>
          </Reveal>

          <Reveal delay={0.44} className="flex min-h-0" data-id="element-409" data-mp="26vqt32k4zg47">
            <Panel index="B" label="Why this matters for LEO" className="w-full" data-id="element-410" data-mp="2bvwlwm2578nv">
              <div className="grid grid-cols-4 gap-[1vw]" data-id="element-411" data-mp="2btscjolh5hg7">
                {LEO_FACTS.map(fact => <div key={fact.label} data-id="element-412" data-mp="2goz8ubcezjv3">
                    <p className="text-[clamp(16px,2.4vw,46px)] font-semibold leading-none tracking-[-0.02em] text-[#A26BFF]" data-id="element-413" data-mp="2kogf36zo0l1b">
                      {fact.value}
                    </p>
                    <p className={`${t.label} mt-[0.8vh] leading-[1.25] text-white/50`} data-id="element-414" data-mp="2uluvx7pi3bu5">
                      {fact.label}
                    </p>
                  </div>)}
              </div>
              <Bullet data-id="element-415" data-mp="2zpwzu7y9cyun">
                Wide portfolio, many markets, heavily weighted toward legacy products
              </Bullet>
              <Bullet data-id="element-416" data-mp="2qqjr5hhykeaz">
                The need is not true in-housing — it is visibility, control, and no
                surprises across markets
              </Bullet>
            </Panel>
          </Reveal>
        </div>
      </div>
    </SlideFrame>;
}